import { render, staticRenderFns } from "./GlobalTip.vue?vue&type=template&id=26629d1e&scoped=true&"
import script from "./GlobalTip.vue?vue&type=script&lang=js&"
export * from "./GlobalTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26629d1e",
  null
  
)

export default component.exports